import React, { useEffect, useState } from "react";
import { Button, Modal, Radio, Alert, message } from "antd";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import ButtonLoader from "../ButtonLoader";

const schema = yup.object().shape({
  status: yup.string().required("Status is required"),
});

const DeviceForm = ({
  isModalOpen,
  editingScreen,
  closeModal,
  handleUpdateList,
}) => {
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [errorsMessage, setErrorsMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [dataSet, setDataSet] = useState(null);
  const [statusOptions, setStatusOptions] = useState([
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
  ]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    context: { isEdit: !!editingScreen },
    defaultValues: {
      status: "active",
    },
  });

  const fetchData = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/devices/${id}`
      );
      setDataSet(response.data.data);
      const status = response.data.data.status;
      
      // Set the form value to the fetched status
      setValue("status", status);

      setLoading(false);
    } catch (err) {
      console.error(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (editingScreen?.id) {
      fetchData(editingScreen.id);
    }
  }, [editingScreen]);

  const onSubmitScreen = async (formData) => {
    setSubmitting(true);
    setShowErrors(false);
    
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/updateStatus`,
        {
          id: editingScreen.id,
          status: formData.status,
        }
      );
      const updated_row_count = response.data.data.updated_row_count;
      await handleUpdateList();
      if (updated_row_count === 1) {
        message.success("Device updated");
        closeModal();
      }
    } catch (err) {
      console.log(err);
      setErrorsMessage(
        err.response?.data?.message || "An error occurred while updating the device"
      );
      setShowErrors(true);
    } finally {
      setSubmitting(false);
    }
  };

  const handleModalClose = () => {
    reset();
    setShowErrors(false);
    setErrorsMessage("");
    closeModal();
  };

  return (
    <Modal
      title={"Update Device Status"}
      open={isModalOpen}
      onCancel={handleModalClose}
      footer={null}
      maskClosable={false}
    >
      {loading ? (
        <ButtonLoader wrapperClass={`min-h-50`} />
      ) : (
        <>
          {showErrors && (
            <div className="col-sm-12 mb-3">
              <Alert message={errorsMessage} type="error" closeIcon={false} />
            </div>
          )}
          <form onSubmit={handleSubmit(onSubmitScreen)}>
            <div className="mb-3">
              <label className="form-label me-3">Status</label>
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <Radio.Group {...field}>
                    {statusOptions.map((status) => (
                      <Radio value={status.value} key={status.value}>
                        {status.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}
              />
              {errors.status && (
                <div className="text-danger small">{errors.status.message}</div>
              )}
            </div>

            <Button
              type="primary"
              htmlType="submit"
              block
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update"}
            </Button>
          </form>
        </>
      )}
    </Modal>
  );
};

export default DeviceForm;